/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './redux/configureStore';
import Root from './components/Root';
import { initAxios } from './shared/helpers/axiosHelper';
require('./favicon.ico'); // Tell webpack to load favicon.ico
const store = configureStore();
initAxios();

render(
  <AppContainer>
    <Root store={ store } history={ history } />
  </AppContainer>,
  document.getElementById('ReactApp')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={ store } history={ history } />
      </AppContainer>,
      document.getElementById('ReactApp')
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js